// компонент для отображения списка услуг врача
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IServ } from '../../../../interfaces/record.interfaces';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ServModalComponent } from 'src/app/modals/service-modal/service-modal.component';

@Component({
    selector: 'rec-mobile-docsrv-list',
    templateUrl: './rec-mobile-docsrv-list.html',
    styleUrls: ['./rec-mobile-docsrv-list.scss'],
    standalone: false
})
export class recMobileDocsrvList {
    @Input() public staticSrvSelected: number | null = null;
    @Input() public srvList: IServ[] = [];
    @Output() public srvChanged = new EventEmitter<{
        typeEvent: string;
        data: IServ;
    }>();
    @Output() public closeSrvList = new EventEmitter<void>();

    public constructor(private modalService: NgbModal) {}

    public closeSrvListHandler(): void {
        this.closeSrvList.emit();
    }

    public openServDescModal(docSrv: IServ, event: Event) {
        event.stopPropagation();
        const modal = this.modalService.open(ServModalComponent);
        modal.componentInstance.serv = docSrv;
    }

    public srvPicked(srv: IServ): void {
        this.srvChanged.emit({
            typeEvent: 'srvPicked',
            data: srv,
        });
    }
}
